import * as React from 'react'
import { BulkActionsLabel } from './BulkActionsLabel'

export const SelectedRowCount: React.FC<{ count: number }> = ({ count }) => {
  const label = React.useMemo(() => {
    const label = count === 1 ? 'Record' : 'Records'
    return `${count} ${label}`
  }, [count])

  return <BulkActionsLabel label={label} />
}
SelectedRowCount.displayName = 'SelectedRowCount'
